// A dónde apuntan las llamadas a /api/admin/*.
//
// POR QUÉ EXISTE ESTE ARCHIVO (2026-08-10): el frontend vive en
// au-coaching.com (Vercel) y el backend en au-coaching.onrender.com (Render).
// Para el navegador son SITIOS distintos, así que la cookie de sesión que
// emite Render es una cookie de TERCERA PARTE. Safari la bloquea siempre (ITP
// viene encendido de fábrica) y Chrome la bloquea en incógnito: la cookie no
// se guarda, la petición siguiente va sin sesión, el 401 devuelve al login y
// el login queda en bucle. Verificado en vivo: apagando "Prevent Cross-Site
// Tracking" en Safari, entra.
//
// El arreglo es no cruzar de sitio. En producción la base va VACÍA, o sea las
// peticiones salen al mismo origen (au-coaching.com), y el rewrite de
// `/api/admin/:path*` en vercel.json las reenvía a Render. Desde el navegador
// todo ocurre en au-coaching.com y la cookie es de primera parte.
//
// El resto del funnel (video-lead, reviews, pagos…) sigue llamando a Render
// directo con REACT_APP_API_URL: no usa cookies, así que no le afecta.

/**
 * Puro y con el entorno inyectado para poder probarlo: equivocarse acá deja
 * el panel entero inaccesible, y no hay forma de testear `process.env`
 * congelado en tiempo de build.
 */
export const resolverAdminApi = (env = {}) => {
  // Salida de emergencia sin tocar código: si el rewrite fallara, apuntar
  // REACT_APP_ADMIN_API_URL a Render en Vercel devuelve el panel (con el bug
  // de Safari de vuelta, pero accesible) más rápido que revertir un commit.
  if (env.REACT_APP_ADMIN_API_URL !== undefined) return env.REACT_APP_ADMIN_API_URL;
  if (env.NODE_ENV === 'production') return '';
  // En local no hay rewrite de Vercel: hay que ir al backend directo.
  return env.REACT_APP_API_URL || 'http://localhost:3001';
};

export const ADMIN_API = resolverAdminApi(process.env);
